/* Shared antd Table design tokens. Applied app-wide from App.jsx so every <Table> gets
   the same look: tinted header, horizontal dividers only, subtle row hover. */
const TABLE_THEME = {
    headerBg: "#F8F9FB",
    headerColor: "#6B7280",
    headerSplitColor: "transparent",
    headerBorderRadius: 0,
    headerSortActiveBg: "#F1F2F6",
    headerSortHoverBg: "#F1F2F6",
    headerFilterHoverBg: "#E9EAF0",
    borderColor: "#EEF0F4",
    rowHoverBg: "#F7F7FF",
    rowSelectedBg: "#EEEEFE",
    rowSelectedHoverBg: "#E6E6FD",
    bodySortBg: "#FBFBFD",
    footerBg: "#FFFFFF",
    cellPaddingBlock: 12,
    cellPaddingInline: 16,
    cellPaddingBlockMD: 10,
    cellPaddingInlineMD: 12,
    cellPaddingBlockSM: 8,
    cellPaddingInlineSM: 10,
    cellFontSize: 14,
};

export default TABLE_THEME;
